import React from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';
import { Provider } from 'react-redux';
import UserflowTheme from '@lt/components/themes/userflow';

import ErrorBoundary from 'src/error/components/ErrorBoundary';
import Layout from 'src/components/Layout';
import getStore from './store';
import { MODULE_NAME } from '../../constants';
import Gift from './components/Layout';
import type { ViewGiftPageProps } from './types';

type GiftPageProps = ViewGiftPageProps & { logo: string };

const GiftApp = ({ logo, ...props }: GiftPageProps) => (
  <ErrorBoundary>
    <Provider store={getStore({ logo })}>
      <ParallaxProvider>
        <UserflowTheme>
          <Layout {...props} appName={MODULE_NAME.GIFT_CERT}>
            <Gift />
          </Layout>
        </UserflowTheme>
      </ParallaxProvider>
    </Provider>
  </ErrorBoundary>
);

export default GiftApp;
